import { APIField } from "server/services/tables/types/fields";
import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { renderCurrencyIcon } from "blocks/utilities/currency-helpers";
import type { SupportedCurrencies } from "blocks/v2/Form/Field/types";
import { isNumber, isString } from "lodash";

export const FILTERABLE_FIELD_TYPES = [
  "string",
  "multiple_string",
  "labeled_string",
  "multiple_labeled_string",
  "text",
  "multiple_text",
  // 'boolean',
  // 'multiple_boolean',
  // 'number',
  // 'multiple_number',
  // 'decimal',
  // 'multiple_decimal',
  // 'datetime',
  // 'multiple_datetime',
  "uuid",
  "multiple_uuid",
  // 'json',
  // 'multiple_json',
  // 'formula',
  // 'button_trigger_zap',
  // 'button_continue_zap',
  "email",
  "multiple_email",
  "link",
];

export function prettyValue(field: APIField, value: any) {
  if (value == null) return "";
  if (value === true) return "Yes";
  if (value === false) return "No";

  if (field.type === "datetime") {
    const date = parseISO(value);
    const options = field.options || {};
    const dateFormat = `${options.date_format || "yyyy-MM-dd"} ${
      options.include_time ? options.time_format || "HH:mm" : ""
    }`;
    // Display in the same format that we see in Tables (Default to UTC timezone)
    return formatInTimeZone(date, options.timezone || "UTC", dateFormat);
  }

  if (field.type === "currency" && field.options?.currency_format) {
    return `${renderCurrencyIcon(
      field.options.currency_format as SupportedCurrencies
    )} ${value}`;
  }

  if (isNumber(value) || isString(value)) return value;
  if (typeof value === "object") {
    // links
    if (value.link && value.text) {
      return (
        <a href={value.link} title={value.text}>
          {value.text}
        </a>
      );
    }

    // dropdown (labeled_string)
    if (value.label && value.value) {
      return value.label;
    }

    // multiple_*
    if (Array.isArray(value)) {
      if (value.length === 0) return "";

      // multiple_labeled_string
      if (value[0].label && value[0].value) {
        return value.map(({ label }) => label).join(", ");
      }
    }
  }
  return JSON.stringify(value);
}
